import { useState, useEffect } from 'react';

export const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? item : initialValue;
    } catch (error) {     
      throw error;    
    }
  });

  const setValue = (value) => {
    try {
      setStoredValue(value);
      if (value === null || value === undefined) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, value);
      }     
      window.dispatchEvent(new CustomEvent('localStorageChange', {
        detail: { key, value }
      }));
    } catch (error) {    
      throw error;
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.detail && e.detail.key === key) {
        setStoredValue(e.detail.value);
      }
    };
    window.addEventListener('localStorageChange', handleStorageChange);
    const handleStorageEvent = (e) => {
      if (e.key === key) {
        setStoredValue(e.newValue);
      }
    };
    window.addEventListener('storage', handleStorageEvent);

    return () => {
      window.removeEventListener('localStorageChange', handleStorageChange);
      window.removeEventListener('storage', handleStorageEvent);
    };
  }, [key]);

  return [storedValue, setValue];
};

export const useSelectedDealership = () => {
  return useLocalStorage('selectedDealershipId', '');
};
